import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "motion/react";
import { AdminSidebar } from "./AdminSidebar";
import { Header } from "./Header";
import { SidebarInset, SidebarProvider } from "@/shared/components/ui/sidebar";

export function AdminLayout() {
  const location = useLocation();

  return (
    <SidebarProvider>
      <AdminSidebar />
      <SidebarInset className="flex flex-col h-dvh overflow-hidden w-full">
        <div className="h-1 bg-amber-500" />
        <Header />
        <main className="flex-1 min-h-0 flex flex-col overflow-hidden p-4 sm:p-6" tabIndex={0}>
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              className="flex-1 min-h-0 flex flex-col"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15 }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
